const YOUTUBE_ID_PATTERN = /^[A-Za-z0-9_-]{11}$/;

/**
 * Extracts the 11-char video ID from any common YouTube URL form
 * (watch, youtu.be, shorts, embed, with or without extra query params).
 * Returns null for anything that isn't a valid YouTube URL/ID.
 */
export function extractYouTubeId(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return null;
  }

  const host = parsed.hostname
    .replace(/^www\./, "")
    .replace(/^m\./, "")
    .replace(/^music\./, "");
  if (!/(^|\.)youtube\.com$/.test(host) && host !== "youtu.be") {
    return null;
  }

  let candidate: string | null = null;

  if (host === "youtu.be") {
    candidate = parsed.pathname.slice(1).split("/")[0];
  } else if (parsed.pathname === "/watch") {
    candidate = parsed.searchParams.get("v");
  } else if (parsed.pathname.startsWith("/shorts/")) {
    candidate = parsed.pathname.slice("/shorts/".length).split("/")[0];
  } else if (parsed.pathname.startsWith("/embed/")) {
    candidate = parsed.pathname.slice("/embed/".length).split("/")[0];
  }

  if (!candidate || !YOUTUBE_ID_PATTERN.test(candidate)) return null;
  return candidate;
}

/** Privacy-enhanced embed URL (youtube-nocookie.com) for a given video ID. */
export function buildYouTubeEmbedUrl(id: string): string {
  return `https://www.youtube-nocookie.com/embed/${id}`;
}
